<img *ngIf="iconMode == 'url' && url"
  class="image"
  [ngClass]="{ custom: size == 'custom', md: size == 'md' }"
  [attr.src]="url" />

<app-icon *ngIf="iconMode == 'icon' && icon" [icon]="icon" [size]="size"> </app-icon>
